@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--hcr-spacing-2);
  padding: var(--hcr-spacing-4) 0;
  text-align: center;
}

.icon {
  color: var(--hcr-content-secondary-color);
}

.actions {
  display: flex;
  gap: var(--hcr-spacing-2);
  align-items: center;
}
